(() => {
  const SUCCESS_MS = 2500;

  const getAtcButtonsForForm = (form) => {
    if (!form) return [];

    return Array.from(form.elements).filter((element) => element.matches?.('[data-td-product-atc]'));
  };

  const clearSuccessState = (button) => {
    if (!button) return;

    button.classList.remove('is-success');

    if (button._tdAtcSuccessTimer) {
      clearTimeout(button._tdAtcSuccessTimer);
      button._tdAtcSuccessTimer = null;
    }
  };

  const showSuccessState = (button) => {
    if (!button || button.disabled) return;

    clearSuccessState(button);
    button.classList.add('is-success');
    button._tdAtcSuccessTimer = setTimeout(() => {
      clearSuccessState(button);
    }, SUCCESS_MS);
  };

  const onFormVariantAdd = (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;

    getAtcButtonsForForm(form).forEach(showSuccessState);
  };

  const onFormVariantChange = (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    getAtcButtonsForForm(form).forEach(clearSuccessState);
  };

  const syncStickyDropdownUI = (select) => {
    const root = select.closest('[data-td-sticky-dropdown]');
    if (!root) return;

    const selectedOption = select.options[select.selectedIndex];
    const label = root.querySelector('[data-td-sticky-dropdown-value]');

    if (label && selectedOption) {
      label.textContent = selectedOption.textContent.trim();
    }

    root.querySelectorAll('[data-td-sticky-dropdown-option]').forEach((option) => {
      const isSelected = option.getAttribute('data-value') === select.value;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  };

  const closeStickyDropdown = (root) => {
    if (!root) return;

    root.classList.remove('is-open');

    const trigger = root.querySelector('[data-td-sticky-dropdown-trigger]');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.removeAttribute('aria-activedescendant');

    root.querySelectorAll('[data-td-sticky-dropdown-option].is-active').forEach((option) => {
      option.classList.remove('is-active');
    });
  };

  const closeAllStickyDropdowns = (except) => {
    document.querySelectorAll('[data-td-sticky-dropdown].is-open').forEach((root) => {
      if (root !== except) closeStickyDropdown(root);
    });
  };

  const getEnabledStickyOptions = (root) =>
    Array.from(root.querySelectorAll('[data-td-sticky-dropdown-option]')).filter(
      (option) => option.getAttribute('aria-disabled') !== 'true'
    );

  const setActiveStickyOption = (root, option) => {
    root.querySelectorAll('[data-td-sticky-dropdown-option]').forEach((item) => {
      item.classList.toggle('is-active', item === option);
    });

    const trigger = root.querySelector('[data-td-sticky-dropdown-trigger]');
    if (trigger && option?.id) {
      trigger.setAttribute('aria-activedescendant', option.id);
    }

    option?.scrollIntoView({ block: 'nearest' });
  };

  const openStickyDropdown = (root) => {
    closeAllStickyDropdowns(root);
    root.classList.add('is-open');

    const trigger = root.querySelector('[data-td-sticky-dropdown-trigger]');
    trigger?.setAttribute('aria-expanded', 'true');

    const selected =
      root.querySelector('[data-td-sticky-dropdown-option].is-selected:not([aria-disabled="true"])') ||
      getEnabledStickyOptions(root)[0];

    if (selected) setActiveStickyOption(root, selected);
  };

  const chooseStickyOption = (option) => {
    const root = option.closest('[data-td-sticky-dropdown]');
    const select = root?.querySelector('[data-td-sticky-variant-select]');

    if (!root || !select || option.getAttribute('aria-disabled') === 'true') return;

    if (select.value !== option.getAttribute('data-value')) {
      select.value = option.getAttribute('data-value');
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncStickyDropdownUI(select);
    closeStickyDropdown(root);
  };

  const syncStickySelectFromForm = (formId) => {
    const stickySelect = document.querySelector(
      `[data-td-sticky-variant-select][data-form-id="${CSS.escape(formId)}"]`
    );

    if (!stickySelect) return;

    const optionPosition = stickySelect.dataset.optionPosition;
    const checkedInput = document.querySelector(
      `input[data-option-position="${CSS.escape(optionPosition)}"][form="${CSS.escape(formId)}"]:checked`
    );

    if (checkedInput && stickySelect.value !== checkedInput.value) {
      stickySelect.value = checkedInput.value;
    }

    syncStickyDropdownUI(stickySelect);
  };

  const getCheckedOptionValues = (form, replacePosition, replaceValue) => {
    const byPosition = new Map();

    Array.from(form.elements).forEach((item) => {
      if (!item.matches?.('input[data-option-position]:checked')) return;

      const position = item.getAttribute('data-option-position');
      if (!byPosition.has(position)) {
        byPosition.set(position, item.value);
      }
    });

    byPosition.set(String(replacePosition), replaceValue);

    return [...byPosition.entries()]
      .sort((a, b) => parseInt(a[0], 10) - parseInt(b[0], 10))
      .map(([, value]) => value);
  };

  const syncFormFromStickySelect = (select) => {
    const formId = select.dataset.formId;
    const optionPosition = String(select.dataset.optionPosition || '');
    const optionValueId = select.value;

    if (!formId || !optionPosition || optionValueId === '') return;

    const form = document.forms[formId];
    if (!form) return;

    const picker = Array.from(document.querySelectorAll('variant-picker')).find(
      (element) => element.getAttribute('form-id') === formId
    );

    const optionInputs = picker
      ? Array.from(picker.querySelectorAll(`input[data-option-position="${optionPosition}"]`))
      : Array.from(form.elements).filter((item) => item.matches?.(`input[data-option-position="${optionPosition}"]`));

    const targetInput = optionInputs.find((input) => input.value === optionValueId);

    if (targetInput?.checked) return;

    if (picker && typeof picker.selectCombination === 'function') {
      picker.selectCombination({
        optionValues: getCheckedOptionValues(form, optionPosition, optionValueId),
        productChange: Boolean(targetInput?.hasAttribute('data-product-url')),
      });
      return;
    }

    if (!targetInput) return;

    targetInput.click();
  };

  const bindFooterVisibility = (stickyBar) => {
    if (stickyBar._tdFooterObserver) return;

    const footer = document.querySelector('.shopify-section--footer');
    if (!footer) return;

    const observer = new IntersectionObserver((entries) => {
      const footerEntry = entries.find((entry) => entry.target === footer);
      if (!footerEntry) return;

      stickyBar.classList.toggle('is-hidden-by-footer', footerEntry.isIntersecting);
    });

    observer.observe(footer);
    stickyBar._tdFooterObserver = observer;
  };

  // Kept in memory only: a variant change re-renders the bar, and it should stay
  // dismissed for the rest of the page view. A reload brings it back.
  let isDismissed = false;

  const dismissStickyBars = () => {
    isDismissed = true;
    closeAllStickyDropdowns();

    document.querySelectorAll('.td-product-sticky-bar').forEach((stickyBar) => {
      stickyBar.classList.add('is-dismissed');
    });
  };

  const bindStickyBar = (stickyBar) => {
    if (isDismissed) stickyBar?.classList.add('is-dismissed');

    if (!stickyBar || stickyBar.dataset.tdStickyBound === 'true') return;

    stickyBar.dataset.tdStickyBound = 'true';
    bindFooterVisibility(stickyBar);
    syncStickySelectFromForm(stickyBar.getAttribute('form'));
  };

  const initStickyBar = (root = document) => {
    root.querySelectorAll('.td-product-sticky-bar').forEach((stickyBar) => {
      bindStickyBar(stickyBar);
    });
  };

  const onOptionChange = (event) => {
    const stickySelect = event.target.closest?.('[data-td-sticky-variant-select]');

    if (stickySelect) {
      syncFormFromStickySelect(stickySelect);
      return;
    }

    if (!event.target.matches?.('input[data-option-position]')) return;

    const formId = event.target.getAttribute('form');
    if (formId) syncStickySelectFromForm(formId);
  };

  document.addEventListener('variant:add', onFormVariantAdd);
  document.addEventListener('variant:change', onFormVariantChange);
  document.addEventListener('cart:error', onFormVariantChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyBar());
  } else {
    initStickyBar();
  }

  document.addEventListener('change', onOptionChange, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-td-sticky-close]')) {
      dismissStickyBars();
      return;
    }

    const option = event.target.closest('[data-td-sticky-dropdown-option]');
    if (option) {
      event.preventDefault();
      chooseStickyOption(option);
      return;
    }

    const trigger = event.target.closest('[data-td-sticky-dropdown-trigger]');
    if (trigger) {
      const root = trigger.closest('[data-td-sticky-dropdown]');
      if (!root) return;

      if (root.classList.contains('is-open')) {
        closeStickyDropdown(root);
      } else {
        openStickyDropdown(root);
      }
      return;
    }

    if (!event.target.closest('[data-td-sticky-dropdown]')) {
      closeAllStickyDropdowns();
    }
  });

  document.addEventListener('keydown', (event) => {
    const openRoot = document.querySelector('[data-td-sticky-dropdown].is-open');
    if (!openRoot) return;

    if (event.key === 'Escape') {
      closeStickyDropdown(openRoot);
      openRoot.querySelector('[data-td-sticky-dropdown-trigger]')?.focus();
      return;
    }

    const options = getEnabledStickyOptions(openRoot);
    if (!options.length) return;

    const current = openRoot.querySelector('[data-td-sticky-dropdown-option].is-active') || options[0];
    const currentIndex = Math.max(0, options.indexOf(current));

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActiveStickyOption(openRoot, options[Math.max(0, currentIndex - 1)]);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActiveStickyOption(openRoot, options[Math.min(options.length - 1, currentIndex + 1)]);
    } else if (event.key === 'Home') {
      event.preventDefault();
      setActiveStickyOption(openRoot, options[0]);
    } else if (event.key === 'End') {
      event.preventDefault();
      setActiveStickyOption(openRoot, options[options.length - 1]);
    } else if ((event.key === 'Enter' || event.key === ' ') && event.target.closest('[data-td-sticky-dropdown]')) {
      event.preventDefault();
      chooseStickyOption(current);
    }
  });

  document.addEventListener('variant:change', () => {
    document.querySelectorAll('[data-td-sticky-variant-select]').forEach((select) => {
      syncStickySelectFromForm(select.dataset.formId);
    });
  });

  document.addEventListener(
    'product:rerender',
    () => {
      // Re-applied straight away as well, so a rerendered bar cannot flash back for a frame.
      if (isDismissed) dismissStickyBars();

      requestAnimationFrame(() => initStickyBar());
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    initStickyBar(event.target);
  });
})();
